import { replace } from 'react-router-redux';

export const CREATE_QUESTION = 'CREATE_QUESTION';
export const UPDATE_QUESTION = 'UPDATE_QUESTION';
export const MOVE_QUESTION_UP = 'MOVE_QUESTION_UP';
export const MOVE_QUESTION_DOWN = 'MOVE_QUESTION_DOWN';
export const DELETE_QUESTION = 'DELETE_QUESTION';

function questionCreated(fields) {
  return {
    type: CREATE_QUESTION,
    payload: {
      fields,
    },
  };
}

export function createQuestion(fields) {
  return dispatch => {
    dispatch(questionCreated(fields));
    // Redirecting to questions list
    dispatch(replace('/questions'));
  };
}

export function updateQuestion(question) {
  return {
    type: UPDATE_QUESTION,
    payload: {
      question,
    },
  };
}

export function moveQuestionUp(question) {
  return {
    type: MOVE_QUESTION_UP,
    payload: {
      question,
    },
  };
}

export function moveQuestionDown(question) {
  return {
    type: MOVE_QUESTION_DOWN,
    payload: {
      question,
    },
  };
}

export function deleteQuestion(question) {
  return {
    type: DELETE_QUESTION,
    payload: {
      question,
    },
  };
}



// WEBPACK FOOTER //
// ./src/modules/funnel/actions/question.js